export default {
  common: {
    answer: 'Answer',
    send: 'Send',
    selectNumberOfPointsToSend: 'Select the number of points to send',
    informationForExtensionFile: 'Information for the Extension of attach file',
    viewVideo: 'View video',
    file: 'File',
    close: 'Close',
    sendPoint: 'Send Point',
    download: 'Download',
    downloadFile: 'Download: {filename}',
    comment: 'Comment',
    coin: 'Coin',
    point: 'Point',
    countSuffix: '',
    login: 'Login',
    unsolved: 'Unsolved',
    resolved: 'Resolved',
    male: 'Male',
    female: 'Female',
    on: 'On',
    off: 'Off',
    all: 'All',
    notAllowedFileType: 'Not allowed file type',
    congratulation: 'Congratulation!',
    receivedPointFromCompany: 'You received {n} point from company',
    receivedCreditFromCompany: 'You received {n} credit from company',
    note: 'Note',
    message: 'Message',
    warning_maintenance_title: 'System maintenance',
    warning_maintenance1:
      'Because we are currently performing system maintenance, Cheeers cannot be used.',
    warning_maintenance2: 'We apologize for the inconvenience, We appreciate your understanding.',
    warning_maintenance_footer: 'For more information, please contact us from inquiries.',
    system_notify: 'Notification from system',
  },
  time: {
    day: 'Day',
    minute: 'minute',
    second: 'second',
    hours: '0 hour | an hour | {count} hours',
    days: '0 day | a day | {count} days',
    months: '0 month | a month | {count} months',
    weeks: '0 week | a week | {count} weeks',
    years: '0 year | a year | {count} years',
    nHours: '0 hour | 1 hour | {count} hours',
    nMinutes: '0 minute | 1 minute | {count} minutes',
    nSeconds: '0 second | 1 second | {count} seconds',
    inToday: 'In today',
    untilTomorrow: 'Until tomorrow',
    inDays: 'in 0 day | in 1 day | in {count} days',
    inWeeks: 'in 0 week | in 1 week | in {count} weeks',
    inMonths: 'in 0 month | in 1 month | in {count} months',
  },
  calendar: {
    formatMonthDay: 'Do (ddd)',
  },
  lang: {
    ja: '日本語',
    en: 'English',
    vi: 'Tiếng Việt',
  },
  menu: {
    home: 'Home',
    issue: 'Questions',
    message: 'Thanks',
    exchange: 'Exchange',
    eLearning: 'E-Learning',
    bulletinBoard: 'Bulletin board',
    profile: 'Profile',
  },
  issue: {
    myQuestionBox: 'History my question',
    supporting: 'Supporting',
    unResolved: 'UnResolved',
    solved: 'Resolved',
    resolveBySelf: 'Resolved by self',
    all: 'All',
    changeToResolved: 'Change to resolved',
    whoHelpToResolve: 'Resolver of this post',
    shareHowToSolveProblem: "Let's share with everyone how we solved it!",
    noOneHelpToResolve: 'Resolved by self',
    resolve: 'Post content',
    choose: 'Choose',
    choosePoint: 'Choose point to give resolver',
    selected: 'Selected',
    addReaction: 'Send a reaction',
    body: {
      solved: 'Solved',
    },
    download: '[{filename}]: Download',
  },
  navbar: {
    attendanceManagement: 'Attendance management',
    working: {
      start: 'Start to work',
      startBreak: 'Have a break',
      finishBreak: 'Finish a break',
      stop: 'Finish working',
      dailyReport: 'Daily report',
    },
    setting: 'General setting',
    logout: 'Logout',
    workingTime: 'Working time',
    attendanceTable: 'Attendance',
  },
  sidebar: {
    cheeersCoin: 'Cheeers coin',
    exchangeForGoods: 'Exchange for Goods',
    remainPoint: 'Remain point',
    expireTime: 'Until the points disappear',
    coinRaking: 'Coin ranking',
    sendGift: 'Send gift',
    receivedThanksRanking: 'Received thanks ranking',
    sendThanksRanking: 'Send thanks ranking',
    byMonth: 'By month',
  },
  login: {
    noteSarafi: '※ Please enable cookie settings',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot password',
    rememberUsername: 'Remember info user',
    language: 'Select language',
  },
  validation: {
    alpha: 'The {_field_} field may only contain alphabetic characters',
    alpha_num: 'The {_field_} field may only contain alpha-numeric characters',
    alpha_dash:
      'The {_field_} field may contain alpha-numeric characters as well as dashes and underscores',
    alpha_spaces: 'The {_field_} field may only contain alphabetic characters as well as spaces',
    between: 'The {_field_} field must be between {min} and {max}',
    confirmed: 'The {_field_} field confirmation does not match',
    digits: 'The {_field_} field must be numeric and exactly contain {length} digits',
    dimensions: 'The {_field_} field must be {width} pixels by {height} pixels',
    email: 'The {_field_} field must be a valid email',
    excluded: 'The {_field_} field is not a valid value',
    ext: 'The {_field_} field is not a valid file',
    image: 'The {_field_} field must be an image',
    integer: 'The {_field_} field must be an integer',
    length: 'The {_field_} field must be {length} long',
    max_value: 'The {_field_} field must be {max} or less',
    max: 'The {_field_} field may not be greater than {length} characters',
    mimes: 'The {_field_} field must have a valid file type',
    min_value: 'The {_field_} field must be {min} or more',
    min: 'The {_field_} field must be at least {length} characters',
    numeric: 'The {_field_} field may only contain numeric characters',
    oneOf: 'The {_field_} field is not a valid value',
    regex: 'The {_field_} field format is invalid',
    required_if: 'The {_field_} field is required',
    required: 'The {_field_} field is required',
    size: 'The {_field_} field size must be less than {size}KB',
    double: 'The {_field_} field must be a valid decimal',
    banned_file_type: '@:common.notAllowedFileType',
    file_attachment: '@:common.notAllowedFileType',
    wrongCredential: 'Wrong username or password',
    notEnoughPoint: "You don' have enough point",
    strong_password: '{_field_} must contain both lower, uppercase character and number',
    max_size_file: 'The file size must be less than {max_size}MB',
  },
  home: {
    listQuestion: "Everyone's question",
    all: 'ALl',
    unsolved: 'Unsolved',
    resolved: 'Resolved',
    cooperated: 'Cooperated',
    sort: 'Sort',
    btnPostQuestion: 'Post a question',
    issueItem: {
      header: {
        postIssueCreated: 'Posting time',
        btnUnresolved: 'Unresolved',
        btnResolved: 'Resolved',
        supporting: 'Supporting',
        coinEarn: 'Coin you can earn',
        endRecruitment: 'Until the end of recruitment',
      },
      contentRight: {
        btnTalk: 'トークする',
        btnApplied: 'Applied',
        now: 'Now',
        peopleAppling: 'people are applying',
        earnCoin: 'earn Coin ',
      },
      contentLeft: {
        btnResolved: 'Resolved ！',
      },
      comments: {
        talkTo: 'Talk to {name}',
      },
    },
    dialogPostQuestion: {
      post: 'Post a question',
      type: 'Choose type question?',
      title: 'The title for the question',
      content: 'Content for question',
      expiredTime: 'How long do you want to solve it ?？',
      timeLine: 'time',
      submit: 'Post a question',
    },
  },
  profile: {
    title: 'Profile',
    avatarTitle: 'Photo',
    informationTitle: 'Information',
    maxFileSizeWarning: 'Max file size: {size}',
    button: {
      uploadAvatar: 'Register new photo',
      submit: 'Save information',
    },
    field: {
      avatar: 'Photos are automatically round trimming',
      name: 'Name',
      email: 'Email address',
      birthday: 'Birthday',
      gender: 'Gender',
      status: 'Comment',
    },
    cumulative: 'Cumulative total',
    coinsReceived: 'Coins received',
    numTimesReceived: 'Number of times received',
    yearOfService: 'Years of service',
  },
  setting: {
    title: 'Setting',
    languageSetting: 'Language',
    notificationSetting: 'Notification',
    receivePostNotification: 'Receive post notification',
    receiveThanksNotification: 'Receive thanks notification',
    receiveTalkNotification: 'Receive talk notification',
    pointSetting: 'Point',
    pointSettingNote1: 'You can set 5 point values',
    pointSettingNote2: 'You can change it any time',
    passwordSetting: 'Password',
    newPassword: 'New password',
    newPasswordConfirm: 'New password confirm',
    updated: 'Update successfully',
  },
  thanks: {
    title: 'Thank message',
    addThanks: 'Send thanks message',
    earnCoin: 'Receive',
    showMore: 'Show more',
    showLess: 'Show less',
    filter: {
      all: 'All messages',
      forYou: 'For you',
      fromMe: 'From you',
    },
  },
  addThanks: {
    title: 'Send thanks',
    filter: {
      branch: 'Branch',
      group: 'Group',
      search: 'Search',
    },
    button: {
      thank: 'Send thanks',
      submit: 'Send thanks',
    },
    selectPoint: 'Select point to give',
    message: 'Write a thank message',
    category: 'Thank category',
    sendAThankMessageTo: 'Send a thank message to {name}',
  },
  exchange: {
    title: 'Benefit',
    sidebar: {
      title: 'Exchange coins',
    },
    content: {
      title: 'List items',
      viewDetail: 'View detail',
    },
    itemDetail: {
      title: 'Product details',
      exchangeForProduct: 'Exchange for product',
      dontHaveProductInStock: "Don't have the product in stock",
      dontHaveEnoughCoin: "Don't have enough coin",
    },
    history: {
      title: 'My order',
    },
    purchaseCompleted: {
      title: 'Purchase completed',
      thanks: 'Thanks you exchanged the product !',
      receivingMethodBelow: 'Please check the item receiving method below。',
      methodReceive: 'How to receive the gift',
      doneStock: 'It is available at the office you can take it.',
      close: 'Close',
      instructionReceiveProduct: 'Instruction receive the product :',
    },
  },
  systemNotification: {
    receivedPoint: {
      title: 'Congratulation ！',
      given: 'given',
      forYou: 'for you！',
      exchange: 'Confirm comment',
    },
    popUp: {
      confirm: 'Do you want to leave this page? Comments you enter will not be saved.'
    }
  },
  working: {
    actions: {
      checkin: {
        success: 'Checkin success. Have a nice day!',
        fail: 'Checkin fail. Please contact your manager!',
        title: 'Start working?',
      },
      checkout: {
        success: 'Checkout success',
        fail: 'Checkout fail. Please contact your manager!',
        title: 'Finish working?',
      },
      pause: {
        success: 'Pause success',
        fail: 'Pause fail. Please contact your manager!',
        title: 'Have a break?',
      },
      continue: {
        success: 'Continue success',
        fail: 'Continue fail. Please contact your manager!',
        title: 'Restart working?',
      },
      overwork: {
        success: 'Continue success',
        fail: 'action fail. Please contact your manager!',
      },
    },
  },
  eLearning: {
    date: 'Date',
    sendSuccess: 'Send Success',
    allCategory: '@:common.all',
    learningProgress: 'Read',
    correctAnswer: 'Score',
    answerProgress: 'Answer progress',
    numberOfCorrectAnswer: 'Correct answers',
    notAttended: 'Not attended',
    question: 'Question',
    nQuestions: '0 question | 1 question | {n} questions',
    learn: 'View document',
    viewTestResult: 'View test result',
    doTheTest: 'Take the test',
    startTheTest: 'Start the test',
    pageNumber: 'Total pages',
    nPages: '0 page | 1 page | {n} pages',
    limitTime: 'Limited time',
    testResult: 'Test result',
    questionNoN: 'Question No.{n}',
    numberOfQuestion: 'Total questions',
    testQuestionNote: '※ There is a time limit for answering each question',
    remainTimeToAnswer: 'Remaining time',
    nextQuestion: 'Next question',
  },
  attendance: {
    title: 'Attendance management',
    checkAttendanceTable: 'Check the attendance table',
    checkDailyAttendance: 'Check daily attendance',
    stamp: 'Time stamp',
    checkinTime: 'Start work',
    checkoutTime: 'End work',
    startBreak: 'Start break',
    endBreak: 'End break',
    workingHours: 'Working time',
    overtimeHours: 'OVer time',
    dailyReport: 'Daily report',
  },
  bulletin: {
    create: {
      titleHeader: 'Post a Bulletin',
      title: 'The title for the bulletin',
      contentTitle: 'Share anything!',
      imageTitle: 'Add image',
      attachFile: 'Add attachment',
      submit: 'Post',
      contentPlaceholder: 'Please enter the content here',
      chooseImage: 'Choose image',
      chooseAttachment: 'Choose Attachment',
      txtFieldTitleName: 'Bulletin title',
      txtFieldContentName: 'Bulletin content',
    },
  },
  dailyReport: {
    title: "Send today's report",
    comment: "Enter today's comment report",
    attachment: 'Attachment',
    chooseFileAttachment: 'Choose file attachment',
    selectIcons: 'select icon',
    submit: 'Post a Report',
  },
  order: {
    statuses: {
      completed: 'Completed',
      new: 'New',
    },
  },
  forgotPassword: {
    title: 'Forgot Password',
    wrongOtp: 'OTP is not matched, please check again',
    continue: 'Continue',
    email: 'Email',
    retrievePassword: 'Retrieve Password',
    changeEmail: 'Change email',
    otp: 'Your OTP',
    resendOtp: 'Resend OTP',
    sentOtp: 'We have sent an OTP to {email}, please check it.',
    sentNewOtp: 'We have sent the OTP to your email',
    password: 'New Password',
    confirmPassword: 'Confirm password',
    successfullyUpdated: 'Successfully updated new password',
    failedToUpdated: 'An error occur when handle your request, please try again',
  },
  editComment: {
    title: 'Edit comment',
    submit: 'Edit',
    delete: 'Delete',
    message: 'Message',
    txtFieldCommentName: 'Solutions',
  },
  surveyQuestion: {
    number: 'Question {0}',
    dialog: {
      content1: 'Cheeers Survey',
      content2: 'Please cooperate with the internal interaction survey',
      start: 'Start now',
    },
  },
  mission: {
    notice: 'The Company need {times} more times to clear this mission',
    letClearMission: "Let's clear the mission together everybody !",
    deadline: 'Deadline',
    clear: 'The mission had cleared !',
    title: 'Mission',
    currentEarnedTrophy: 'Current Earned Trophy',
    finish: "Let's complete the mission !",
    missionOfMonth: 'This month mission {0}/{1}/{2} ~ {3}/{4}/{5}',
    startMission: "Mission started! Let's execute!",
    fiftyPercent: 'Breakthrough {times} turns! The turning point!',
    clearMission: 'Complete the mission! congratulation!',
    item: {
      content: 'Let\'s all aim to <span class="font-weight-bold">{content}</span> in this month !',
    },
    popUp: {
      text1: 'Mission {number}',
      text2: 'Completed !!',
    },
    trophyVision: 'Vision',
    trophyRelationships: 'Relationships',
    trophyContribute: 'Contribute',
    trophyGrowth: 'Growth',
    trophyAttendance: 'Attendance',
  },
  sloganAnswer: {
    question: "What is your company's {slogan} ?",
    correctAnswer: 'Wonderful! Correct answer!',
    errorMessage:
      'Unfortunately, the correct answer is "{correctAnswer}". Would you like to try again?',
    yes: 'yes',
    cancel: 'Cancel',
  },
};
